var vista = vista || {};
vista.Vista  = Class.extend(
    function(){
        /**
         * Devuelve el html de la vista
         * @return string HTML generado
         */
        this.generar = function(){
            throw "La vista debe implementar el método generar";
        };

        this.toString = function(){
          return this.generar();
        };

        /**
         * Devuelve la clase asociada a la vista
         * @return {css.Clase} Clase asociada
         */
        this.obtenerClaseCss = function(){
            return new css.Clase();
        };
    }
);
